import type {Validator} from 'svelte-forms';
import {isDefined} from 'shared/utils/custom-utils';
import type {BooleanValueEditorOptions, BooleanValueEditorValidations} from './types';
import type {Formatter, Parser} from '../../internal/forms/types';

export function validatorFactory(validations: BooleanValueEditorValidations): Validator[] {
    const validators: Validator[] = [];

    if (isDefined(validations.required)) {
        validators.push((value: boolean) => ({valid: !(value === undefined || value === null), name: 'required'}));
    }

    if (isDefined(validations.assertTrue)) {
        validators.push((value: boolean) => ({valid: value === true, name: 'required'}));
    }

    return validators;
}

export function formatToCustomValue(options: BooleanValueEditorOptions): Formatter {
    return (value: unknown) => {
        if (options.trueValue !== undefined && value === options.trueValue) {
            return true;
        }

        if (options.falseValue !== undefined && value === options.falseValue) {
            return false;
        }

        return value;
    }

}

export function parseFromCustomValue(options: BooleanValueEditorOptions): Parser {
    return (value: boolean) => {
        if (options.trueValue !== undefined && value === true) {
            return options.trueValue;
        }

        if (options.falseValue !== undefined && value === false) {
            return options.falseValue;
        }

        return value;
    };
}
